import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAccount } from "@/lib/account";
import { usePrefs } from "@/lib/prefs";

export default function ShortlistButton({ pid, className = "", label = false }) {
  const { isSignedIn, account, toggleShortlist } = useAccount();
  const { t } = usePrefs();
  const navigate = useNavigate();
  const on = account?.shortlist?.includes(pid);
  const click = (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!isSignedIn) return navigate("/sign-in");
    toggleShortlist(pid);
  };
  return (
    <button onClick={click} data-testid={`shortlist-btn-${pid}`} aria-label="shortlist"
      className={`flex items-center gap-2 rounded-full backdrop-blur transition-colors ${on ? "bg-rose-600/90 text-white" : "bg-black/50 text-white hover:bg-rose-600/70"} ${label ? "px-5 py-3" : "p-2"} ${className}`}>
      <Heart className="w-4 h-4" fill={on ? "currentColor" : "none"} />{label && <span className="text-sm">{on ? t("shortlisted") : t("shortlistBtn")}</span>}
    </button>
  );
}
